<template>
  <div class="modal-wrapper">
    <transition name="slide">
      <div
        class="modal"
        v-if="showModal"
        :class="{ 'modal-bg': lang === 'bg', 'modal-en': lang === 'en' }"
      >
        <form @submit.prevent="create()" @keydown.enter.prevent>
          <div class="row">
            <!-- DATE -->
            <div class="input">
              <label class="label-with-validation" for="newsDate">
                <span>*ДАТА</span>
                <transition name="scale">
                  <span class="kcm kcm-valid" v-if="message.date">R</span>
                </transition>
              </label>
              <input
                type="text"
                id="newsDate"
                :value="message.date | formatDateDot"
                placeholder="ДД.ММ.ГГГГ"
                @change="createNewDateFromString"
                @keyup="formatDate"
              />
            </div>
            <!-- TYPE -->
            <div class="input">
              <label for="newsType">ЦВЯТ НА ФОНА</label>
              <select
                id="newsType"
                v-model="message.background"
                :style="{ background: message.background, color: '#ffffff' }"
              >
                <option
                  v-for="c in colors"
                  :value="c"
                  :key="`color-${c}`"
                  :style="{ background: c }"
                />
              </select>
            </div>
          </div>
          <!-- TITLE -->
          <div class="input" v-show="lang === 'bg'">
            <label for="newsTitle">*Заглавие (до 80 символа)</label>
            <input
              type="text"
              :placeholder="`*${$t('title')}`"
              id="newsTitle"
              v-model="message.bg.title"
            />
          </div>
          <div class="input" v-show="lang === 'en'">
            <label for="newsTitle">*Заглавие (до 80 символа)</label>
            <input
              type="text"
              :placeholder="`*${$t('title')}`"
              id="newsTitle"
              v-model="message.en.title"
            />
          </div>
          <!-- CONTENT 1 -->
          <div class="wrap-q">
            <div class="wrapper-for-quill" v-show="lang === 'bg'">
              <Quill v-model="message.bg.content" />
            </div>
            <div class="wrapper-for-quill" v-show="lang === 'en'">
              <Quill v-model="message.en.content" />
            </div>
          </div>

          <div class="row">
            <div class="input">
              <label for="newsLink">ЛИНК</label>
              <input
                type="text"
                placeholder="Линк"
                id="newsLink"
                v-model="message.link"
              />
            </div>
          </div>
        </form>
        <div class="row row-last">
          <div class="languages">
            <p>ЕЗИЦИ</p>
            <span
              class="lang lang-bg"
              :class="{ 'lang-active': lang === 'bg' }"
              @click="lang = 'bg'"
              >BG</span
            >
            <span
              class="lang lang-en"
              :class="{ 'lang-active': lang === 'en' }"
              @click="lang = 'en'"
              >EN</span
            >
            <div v-if="id" class="buttons">
              <button class="button-delete" @click.prevent="deleteMessage()">
                <span>Изтриване</span>
              </button>
            </div>
          </div>
          <div class="buttons">
            <button class="button-close" @click.prevent="close()">
              <span>Отказ</span>
            </button>
            <button
              class="button-submit"
              :disabled="loading"
              @click.prevent="create()"
            >
              <span v-if="id">{{ $t("edit") }}</span>
              <span v-else>{{ $t("create") }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
    <div
      class="progress"
      :class="{ 'progress-active': loading }"
      :style="{ width: progress + '%' }"
    ></div>
  </div>
</template>

<script>
import Quill from "../shared/Quill";
import colors from "./colors.json";
export default {
  components: {
    Quill,
  },
  props: ["id"],
  data() {
    return {
      colors,
      showModal: false,
      loading: false,
      progress: 0,
      lang: "bg",
      message: {
        date: "",
        background: colors[8],
        bg: {
          title: "",
          content: "",
        },
        en: {
          title: "",
          content: "",
        },
      },
    };
  },
  methods: {
    formatDate(event) {
      event.target.value = event.target.value
        .replace(/[^0-9.]/g, "")
        .substr(0, 10);
    },
    createNewDateFromString(event) {
      const t = event.target.value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (t !== null) {
        const d = +t[1];
        const m = +t[2];
        const y = +t[3];
        const date = new Date(y, m - 1, d);
        if (date.getFullYear() === y && date.getMonth() === m - 1) {
          // return date;
          this.message.date = date;
        } else {
          this.message.date = null;
        }
      } else {
        this.message.date = null;
      }
    },

    getNews() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/message/${this.id}`)
        .then((result) => {
          this.message = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    create() {
      if (this.isValid()) {
        this.loading = true;
        this.progress = 0;

        let url = `${process.env.VUE_APP_BASE_URI}/message`;
        let type = "post";

        if (this.id) {
          url += `/${this.id}`;
          type = "put";
        }

        this.$http[type](url, this.message, {
          onUploadProgress: (ue) => {
            this.progress = Math.round((ue.loaded / ue.total) * 100);
          },
        })
          .then(() => {
            if (this.id) {
              this.$snotify.success("Съобщението е редактирано успешно!");
            } else {
              this.$snotify.success("Успешно създадено съобщение!");
            }
            setTimeout(() => {
              this.close(true);
            }, 300);
          })
          .catch((err) => {
            console.log(err);
            this.$snotify.error("Нещо се обърка, моля опитайте отново.");
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false;
              this.progress = 0;
            }, 1000);
          });
      }
    },
    isValid() {
      if (!this.message.date) {
        this.$snotify.error("Съобщението трябва да има дата.");
        return false;
      }
      if (!this.message["bg"].title) {
        this.$snotify.error(
          "Съобщението трябва да има заглавие на български език."
        );
        return false;
      }

      return true;
    },
    deleteMessage() {
      if (confirm("Сигурни ли сте, че искате да изтриете съобщението?")) {
        let url = `${process.env.VUE_APP_BASE_URI}/message/${this.id}`;
        this.$http
          .delete(url, {
            onUploadProgress: (ue) => {
              this.progress = Math.round((ue.loaded / ue.total) * 100);
            },
          })
          .then(() => {
            this.$snotify.success("Съобщението е изтрито успешно!");
            setTimeout(() => {
              this.close(true);
            }, 300);
          })
          .catch((err) => {
            console.log(err);
            this.$snotify.error("Нещо се обърка, моля опитайте отново.");
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false;
              this.progress = 0;
            }, 1000);
          });
      }
    },
    close(refresh) {
      this.$parent.$emit("close-news-modal", refresh);
    },
  },
  mounted() {
    if (this.id) {
      this.getNews();
    } else {
      this.message.type = this.$route.query.type;
    }
    setTimeout(() => {
      this.showModal = true;
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  min-width: 1000px;
}
.modal {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
  overflow: initial;
  padding: 0;
  @include transition(background-color 0.3s);
  width: 50%;
}
.modal-bg {
  background-color: #f9fcf9;
}
.modal-en {
  background-color: #f9f5f7;
}
form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  margin: 0 auto;
  max-height: calc(100vh - 40px);
  overflow: auto;
  padding: 20px 20px 0;
  width: 100%;
}
.row {
  width: 100%;
}
.row .input {
  margin-right: 10px;
}
.row .input:last-child {
  margin-right: 0;
}
.row .no-margin-right {
  margin-right: 0;
}
.row .label-with-validation {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .kcm {
    color: #000;
  }
  .kcm-valid {
    color: green;
  }
}
.row-gallery {
  flex-wrap: wrap;
}
.progress {
  background-color: $accentColor;
  display: block;
  height: 5px;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 2;
  @include transition(width 0.3s);
}
.progress-active {
  opacity: 1;
}
.row-last {
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  .languages {
    align-items: center;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    display: flex;
    p {
      color: #6f6f6f;
      font-size: 13px;
      line-height: 13px;
      margin-right: 10px;
    }
    .lang {
      @extend %flex-center;
      color: #3d3d3d;
      cursor: pointer;
      font-size: 13px;
      height: 40px;
      @include transition(all 0.2s $mainCubic);
      width: 40px;
    }
    .lang-active.lang-bg,
    .lang:hover.lang-bg {
      background-color: #009105;
      color: #fff;
    }
    .lang-active.lang-en,
    .lang:hover.lang-en {
      background-color: #cf142b;
      color: #fff;
    }
  }
  .buttons {
    button {
      padding: 0 30px;
      span {
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
      }
    }
    .button-close {
      background-color: #dbdbdb;
      color: #000;
    }
    .button-delete {
      background-color: $accentColor;
      margin-left: 10px;
      color: #fff;
    }
    .button-submit {
      margin-left: 10px;
      background-color: $mainColor;
    }
  }
}
.wrap-q {
  width: 100%;
}
.wrapper-for-quill {
  background-color: #f7f7f7;
  width: 100%;
}
</style>
